import React from 'react';
import ItemReportHeader from '../ItemReportHeader';
import ItemReportContent from '../ItemReportContent';

const ItemReport = () => {
    return (
        <>
            <ItemReportHeader />
            <ItemReportContent />
        </>
    );
};

export default ItemReport;
